// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit-details-tags .tags__selected-items .tag{margin-right:.25rem;margin-top:1px}.kit-details-tags--empty .tags__add-btn{display:block!important}.kit-details-tags--empty .tags__add-btn i{margin-left:4px;margin-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
